import React from 'react'
import { env_url } from '../../utils/js/endpoints'
import { dispatchAnalytics } from '../../utils/js/analytic_helpers'
import PropTypes from 'prop-types'

import '../CalReplyPlayoff/CalReplyPlayoff.scss'

const CalReplyPlayoff = props => {
    const { league } = props
    const openCalReplyDialog = league => {
        const cr_url = `https://sportsnet.roktcalendar.com/${league}`
        window.open(
            cr_url,
            '_blank',
            'toolbar=no,location=yes,status=yes,menubar=no,scrollbars=yes,resizable=yes,width=660,height=720'
        )
    }

    const fileExtension = league === 'mlb' ? 'png' : 'svg'

    return (
        <div
            className="CalReply"
            onClick={() => {
                dispatchAnalytics({
                    type: 'DTM_TRACK_ADD_TO_SCHEDULE',
                    origin: 'button',
                })
            }}
            tabIndex={0}
        >
            <div
                className={`calreply-small-size calreply-cont playoff ${league}`}
                onClick={() => openCalReplyDialog(league)}
            >
                <div className={`left-cont playoff-${league}`}>
                    <img
                        src={`${env_url}/${league}-playoff-logo.${fileExtension}`}
                        className="cal-logo-default"
                        alt="calendar logo"
                    />
                    <p className="general-text league-text">
                        {' '}
                        {`Add ${league} Playoff Games to Your Calendar!`}
                    </p>
                </div>
                <div className={`right-cont playoff-${league}`}>
                    <div className="center-me">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="29"
                            viewBox="0 0 34 29"
                        >
                            <defs></defs>
                            <path
                                id="icon"
                                className="cls-1"
                                d="M321,539a8.935,8.935,0,0,1,1,.059V532a1,1,0,0,1,1-1h4v-2h-4a3,3,0,0,0-3,3v7.059A8.935,8.935,0,0,1,321,539Zm23-10h-4v2h4a1,1,0,0,1,1,1v15a1,1,0,0,1-1,1H330a8.971,8.971,0,0,1-.231,2H344a3,3,0,0,0,3-3V532A3,3,0,0,0,344,529Zm1,7H322v-1h23v1Zm-16.5-8a0.507,0.507,0,0,1,.5.5v3a0.5,0.5,0,0,1-1,0v-3a0.507,0.507,0,0,1,.5-0.5m0-1a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,3,0v-3a1.5,1.5,0,0,0-1.5-1.5h0Zm10,1a0.507,0.507,0,0,1,.5.5v3a0.5,0.5,0,0,1-1,0v-3a0.507,0.507,0,0,1,.5-0.5m0-1a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,3,0v-3a1.5,1.5,0,0,0-1.5-1.5h0ZM321,556a8,8,0,1,1,8-8A8.009,8.009,0,0,1,321,556Zm0-14a6,6,0,1,0,6,6A6.006,6.006,0,0,0,321,542Zm1,10h-2v-8h2v8Zm3-3h-8v-2h8v2Zm12-18h-7v-2h7v2Z"
                                transform="translate(-313 -527)"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}
CalReplyPlayoff.propTypes = {
    season: PropTypes.oneOf(['nhl', 'nba']),
    type: PropTypes.oneOf(['league']),
}

export default CalReplyPlayoff
